
export type GetTermsTermsType = typeof GetTermsTermsType[keyof typeof GetTermsTermsType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetTermsTermsType = {
  electronicFinancialTransactions: 'electronicFinancialTransactions',
  collectPersonalInfo: 'collectPersonalInfo',
  sharingPersonalInformation: 'sharingPersonalInformation',
  telecommunicationCharging: 'telecommunicationCharging',
} as const;
